import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import type { ColumnDef } from "../../components/base-table-layout";
import { createEhrWriteBackColumn } from "../../ehr/create-ehr-column";
import { useEhrContext } from "../../../shared-logic/ehr-context/ehr-context";
import { BaseTableLayout } from "../../components/base-table-layout";
import { CodingBadge } from "../../components/coding-badge";
import { TableRow } from "../../utils/tables-metadata";
import { ImmunizationRowData } from "./immunization-rows";

export type ImmunizationTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function ImmunizationTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Immunizations",
  isRowViewed,
}: ImmunizationTableProps) {
  const ehrContext = useEhrContext();

  const columns = useMemo(() => {
    const cols: ColumnDef<ImmunizationRowData>[] = [
      { key: "immunization", header: "Immunization", maxWidth: "300px" },
      {
        key: "code",
        header: "Code",
        render: (row, query) => <CodingBadge coding={row.coding} searchQuery={query} />,
      },
      { key: "manufacturer", header: "Manufacturer" },
      { key: "status", header: "Status" },
      { key: "date", header: "Date", maxWidth: "150px", sort: "desc" },
    ];

    const ehrColumn = createEhrWriteBackColumn<ImmunizationRowData>(ehrContext, "immunization");
    if (ehrColumn) cols.push(ehrColumn);

    return cols;
  }, [ehrContext]);

  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as ImmunizationRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
